export const TransitionAllStyles = {
  transitionProperty: 'all',
  transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1);',
  transitionDuration: '150ms',
};
